import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function searchEmetteurtnt(query, page = 1, start = 0, limit = 20) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.searchEmetteurTnt,
    params: {
      query,
      page,
      start,
      limit
    }
  }).then(r => r.data);
}

function searchSuspicionLte(concatVoie, codePostal, nomCommune) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.searchSuspicionLte,
    urlConfig: {
      pathParams: {
        voie: concatVoie,
        codepostal: codePostal,
        commune: nomCommune
      }
    }
  }).then(r => r.data);
}

export default {
  searchEmetteurtnt,
  searchSuspicionLte,
};



// WEBPACK FOOTER //
// ./src/repositories/emetteurtnt.repository.js